i<template>
  <div>
    <v-overlay
      :value="saving"
    >
      <v-progress-circular
          indeterminate
          size="64"
        ></v-progress-circular>
    </v-overlay>
    <div
      id="openviewer"
      ref="openviewer"
      @contextmenu="handler"
    ></div>
    <div class="options"></div>
    <!-- <div id="menu"> -->
      <ReportDetails
        id="menu"
        class="scrollable"
        :style="{ maxHeight: viewerMaxHeight + ' !important'}"
        @delete-area="deleteArea"
        @select-area="selectArea"
        @center-area="centerArea"
        @save="save"
        @next-report="nextReport"
        @previous-report="previousReport"
        @go-back="goBack"
      >
      </ReportDetails>
      <div class="data"></div>
    <!-- </div> -->
    <div id="edit">
      <v-form ref="form" v-model="valid" lazy-validation>
        <h5 class="font-weight-bold text-center subtitle-2 mb-2">
          {{ $t("report.visualizationView.selectClassTitle") }}
        </h5>
        <v-row
          class="ma-0 pa-0"
        >
          <v-col
          cols="11"
          class="pa-0 ma-0"
          >
            <v-select
              v-model="selectedClass"
              @change="changeClass"
              :items="classChoices"
              item-text="text"
              :hide-details="true"
              item-value="name"
              class="mt-1 pt-1 mb-2"
              :rules="[v => !!v || $t('report.visualizationView.classRules.required')]"
              :label="$t('report.visualizationView.selectClass')"
              required
            >
              <template slot="selection" slot-scope="data">
                <!-- HTML that describe how select should render selected items -->
                <v-row
                  no-gutters
                >
                  <v-col
                    cols="1"
                    xs="1"
                    md="1"
                    :style="{ backgroundColor: data.item.color + ' !important' }" >
                  </v-col>
                  <v-col
                    cols="11"
                    xs="11"
                    md="11"
                    class="px-4"
                  >
                    {{ data.item.text}}
                  </v-col>
                </v-row>
              </template>
              <template slot="item" slot-scope="data">
                <!-- HTML that describe how select should render items when the select is open -->
                <v-row
                  no-gutters
                >
                  <v-col
                    cols="1"
                    xs="1"
                    md="1"
                    :style="{ backgroundColor: data.item.color + ' !important' }" >
                  </v-col>
                  <v-col
                    cols="11"
                    xs="11"
                    md="11"
                    class="px-4"
                  >
                    {{ data.item.text}}
                  </v-col>
                </v-row>
              </template>
            </v-select>
          </v-col>
          <v-col
            cols="1"
            class="pa-0 ma-0 d-flex"
          >
            <v-tooltip
              right
              class="align-self-center"
              max-width="300px"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  color="primary"
                  dark
                  v-bind="attrs"
                  v-on="on"
                >
                  mdi-help-circle-outline
                </v-icon>
              </template>
              <span>
                {{ $t("report.visualizationView.classSelectTooltip.autoArea", { tileCountForArea: minTilesForArea }) }}
              </span>
            </v-tooltip>
          </v-col>
        </v-row>
        <v-row class="my-1" align="center" justify="space-around">
          <v-btn
            color="success"
            class="mr-4"
            @click="saveClassEdit"
            :disabled="!Boolean(selectedClass)"
          >
            {{ $t("report.visualizationView.changeClass") }}
          </v-btn>
          <v-btn color="error" @click="cancelClassEdit">
            {{ $t("button.cancel") }}
          </v-btn>
        </v-row>
      </v-form>
      <div class="data"></div>
    </div>
  </div>
</template>

<script>
import * as turf from "@turf/turf";
import GeoJSON from "ol/format/GeoJSON";
import Projection from "ol/proj/Projection";
import Zoomify from "ol/source/Zoomify";
import Tile from "ol/layer/Tile";
import FullScreen from "ol/control/FullScreen";
import Map from "ol/Map";
import { OverviewMap, Control, defaults as defaultsControls } from "ol/control";
import View from "ol/View";
import * as olExtent from "ol/extent";
import ZoomSlider from "ol/control/ZoomSlider";
import { Fill, Stroke, Style, Text } from "ol/style";
import { easeOut } from "ol/easing";
import { getVectorConstext } from "ol/render";
import { getArea } from "ol/sphere";
// import { unByKey } from "ol/Observable";
import FontSymbol from "ol-ext/style/FontSymbol";
import VectorSource, { VectorSourceEvent } from "ol/source/Vector";
import Feature from "ol/Feature";
import Polygon from "ol/geom/Polygon";
import MultiPolygon from "ol/geom/MultiPolygon";
import GeometryCollection from "ol/geom/GeometryCollection";
import LinearRing from "ol/geom/LinearRing";
import VectorLayer from "ol/layer/Vector";
import { Color } from "ol/color";
import Group from "ol/layer/Group";
import { Select, defaults as defaultInteractions } from "ol/interaction";
import LayerSwitcher from "ol-ext/control/LayerSwitcher";
import Swipe from "ol-ext/control/Swipe";
import Overlay from "ol-ext/control/Overlay";
import Overview from "ol-ext/control/Overview";
import Toggle from "ol-ext/control/Toggle";
import Bar from "ol-ext/control/Bar";
import Legend from "ol-ext/legend/Legend";
import LegendControl from "ol-ext/control/Legend";
import Button from "ol-ext/control/Button";
import ReportDetails from "@/components/service/ReportDetails";
import { feature, geometryCollection, multiPolygon, polygon } from "@turf/turf";
import md5 from "md5";
import { mapState } from "vuex";
import {
  LOAD_DIAGNOSIS,
  ACTION_SET_DIAGNOSIS_COUNT,
  ACTION_SET_DIAGNOSIS_RATIO
} from "@/store/modules/diagnosis";
import {
  SET_CURRENT_INDEX,
  SET_CURRENT_INDEX_REPORTWSI,
  ACTION_ADD_TILE,
  ACTION_DELETE_TILE,
  ACTION_REMOVE_SUSPICIOUS,
  ACTION_SET_LABEL,
  ACTION_ADD_AREA,
  ACTION_EDIT_AREA,
  ACTION_DELETE_AREA,
  UPDATE_REPORT,
  REPORT_NEXT,
  REPORT_PREVIOUS,
  CURRENT_REPORTWSI,
  ACTION_SET_CURRENT_REPORTDIAGNOSIS,
  ACTION_SET_CURRENT_REPORTWSI,
  ACTION_SET_CURRENT_REPORTTILEGRID,
} from "@/store/modules/service";

export default {
  props: {
    slide: Object
  },
  data() {
    return {
      valid: false,
      saving: false,
      selectedClass: null,
      indexCounter: 0,
      allowCreateTiles: false,
      selectedFeatures: [],
      selectedFeaturesInitialState: [],
      selectedWithFill: false,
      featuresTiles: [],
      featureAreas: [],
      tileSize: 0,
      totalSize: 0,
      scalingFactor: 1,
      tileAreamm2: 0.07444444444,
      tileDimensions: [300, 300],
      suspiciousThreshold: 0.5,
      vectorLayerTiles: null,
      vectorLayerAreas: null,
      editOverlay: null,
      map: null,
      format: new GeoJSON(),
      currentHighlightedTile: null,
      currentZoom: 1,
      areaLabelArray: [],
      areaLabelDict: {},
      cursorSizes: [1, 3, 5],
      currentCursorSize: 1,
      deselectMode: false,
    };
  },
  computed: {
    ...mapState({
      reportTileGrid: state => state.service.currentReportTileGrid,
      reportWSI: state => state.service.currentReportWSI,
      diagnosisByName: state => state.diagnosis.byName,
    }),
    viewerMaxHeight() {
      const windowHeight =
        window.screen.availHeight - (window.outerHeight - window.innerHeight);
      const containerPadding = parseInt(
        getComputedStyle(document.getElementsByClassName("container")[0])
          .padding
      );
      const navbarHeight = document.getElementById("appbar").offsetHeight;
      return `${windowHeight -
        navbarHeight -
        containerPadding * 2}px`;
    },
    minTilesForArea() {
      return Math.ceil(this.suspiciousThreshold/this.tileAreamm2)
    },
    extent() {
      return [0, -this.imageHeight, this.imageWidth, 0];
    },
    imageWidth() {
      return this.slide.width;
    },
    imageHeight() {
      return this.slide.height;
    },
    classChoices() {
      const choices = [];
      const sorted_diagnosis = [
        "adenocarcinoma",
        "adenoma",
        "other",
        "normal",
        "artifact",
        "tissue with artifact",
        "background"
      ];
      sorted_diagnosis.forEach(key => {
        choices.push({
          name: this.diagnosisByName[key].name,
          text: this.$t('report.' + this.diagnosisByName[key].name),
          color: this.diagnosisByName[key].color
        });
      });
      return choices;
    },
    tileSizeX() {
      return this.tileDimensions[0]*this.scalingFactor;
    },
    tileSizeY() {
      return this.tileDimensions[1]*this.scalingFactor;
    },
    tileLayerTitle() {
      return this.$t("report.visualizationView.tiles");
    },
    areaLayerTitle() {
      return this.$t("report.visualizationView.areas");
    },
    resolutionAt10x() {
      // base resolution of the WSI, for now all are 1 at 10x magnification
      return 1;
    }
  },
  methods: {
    handler(e) {
      if (e.target.tagName === "CANVAS") {
        e.preventDefault();
      }
    },
    async nextReport() {
      try {
        await this.$store.dispatch(REPORT_NEXT);
        const nextId = await this.$store.getters[CURRENT_REPORTWSI].id
        this.$store.dispatch(LOAD_DIAGNOSIS);
        this.$store.dispatch(ACTION_SET_CURRENT_REPORTWSI, { id: nextId });
        this.$store.dispatch(ACTION_SET_CURRENT_REPORTTILEGRID, { id: nextId });
        this.$store.dispatch(ACTION_SET_CURRENT_REPORTDIAGNOSIS, { id: nextId });
        this.$router.push({
          name: "service-view",
          params: { id: nextId }
        });
      } catch (e) {
        // no more slides available
        this.$router.push({ name: "service" });
      }
    },
    async previousReport() {
      try {
        await this.$store.dispatch(REPORT_PREVIOUS);
        const previousId = await this.$store.getters[CURRENT_REPORTWSI].id
        this.$store.dispatch(LOAD_DIAGNOSIS);
        this.$store.dispatch(ACTION_SET_CURRENT_REPORTWSI, { id: previousId });
        this.$store.dispatch(ACTION_SET_CURRENT_REPORTTILEGRID, { id: previousId });
        this.$store.dispatch(ACTION_SET_CURRENT_REPORTDIAGNOSIS, { id: previousId });
        this.$router.push({
          name: "service-view",
          params: { id: previousId }
        });
      } catch (e) {
        // no more slides available
        this.$router.push({ name: "service" });
      }
    },
    goBack() {
      this.$router.push({ name: "service" })
    },
    reset() {
      this.map.getLayers().forEach(e => this.map.removeLayer(e));
    },
    addLayer(layer) {
      this.map.addLayer(layer);
    },
    resize() {
      document.getElementById("openviewer").style["height"] = this.viewerMaxHeight;
    },
    jumpTo(x, y, zoom) {
      if (zoom === undefined) {
        zoom = 8;
      }
      this.map.getView().animate({
        center: [x, -(y + 30)],
        zoom,
        duration: 200
      });
    },
    getFeatureById(id) {
      const layer = this.map
        .getLayers()
        .getArray()
        .find(e => e.get("key") !== undefined && e.get("key") === "tile");
      return layer.getSource().getFeatureById(id);
    },
    highlightTile(tileId) {
      if (this.currentHighlightedTile !== null) {
        this.currentHighlightedTile.setStyle(
          this.currentHighlightedTile.get("style")
        );
      }
      const feature = this.getFeatureById(tileId);
      feature.set("style", feature.getStyle());
      feature.setStyle(
        new Style({
          zIndex: 10000,
          stroke: new Stroke({
            color: "#3399CC",
            width: 5
          })
        })
      );
      this.currentHighlightedTile = feature;
    },
    toggleFilterFeatures(filter, active) {
      this.getVectorLayers().forEach(layer => {
        layer.getSource().forEachFeature(f => {
          if (filter == f.get("class")) {
            active
              ? f.setStyle(this.setFeatureStyle(f, false))
              : f.setStyle(undefined);
          }
        });
      });
    },
    centerArea(area) {
      const layer = this.vectorLayerAreas;
      const feature = layer.getSource().getFeatureById(area.id);
      if (feature) {
        this.map.getView().fit(feature.getGeometry(), { maxZoom: 3 });
      }
    },
    selectArea(area) {
      const layer = this.vectorLayerAreas;
      const feature = layer.getSource().getFeatureById(area.id);
      // this.cancelClassEdit();
      if (feature) {
        this.selectFeatures([feature], true);
      }
    },
    deleteArea(feature, hardDelete = false) {
      const source = this.vectorLayerAreas.getSource();
      // Area suspicious attribute change to false
      this.$store.dispatch(ACTION_REMOVE_SUSPICIOUS, {
        area_class_id: feature.get("area_class_id"),
        area_id: feature.getId()
      });
      feature.set("suspicious", false);
      feature.setStyle(this.setFeatureStyle(feature));
      if (hardDelete) {
        this.removeLabel(feature)
        this.$store.dispatch(ACTION_DELETE_AREA, {
          area: {
            id: feature.getId(),
            area_class_id: feature.get("area_class_id")
          }
        });
        if (source.getFeatureById(feature.getId())) source.removeFeature(feature);
      }
      this.countSuspiciousAreas();
      this.calculateTotalAreaPercentage();
    },
    addArea(feature) {
      this.setLabel(feature);
      this.$store.dispatch(ACTION_ADD_AREA, {
        area: {
          id: feature.getId(),
          class: feature.get("class"),
          suspicious: feature.get("suspicious"),
          area: feature.get("size"),
          rate: feature.get("ratio")
        }
      });
      if (feature.get("suspicious")) {
        this.$store.dispatch(ACTION_SET_DIAGNOSIS_COUNT, {
          diagnosisName: feature.get("class"),
          count: this.diagnosisByName[feature.get("class")].count + 1
        });
      }
      // this.countSuspiciousAreas();
      this.calculateTotalAreaPercentage();
    },
    setFeatureStyle(feature, withFill = true, color) {
      let fc = "transparent";
      let sc = "#319FD3";
      let label = undefined;
      if (withFill) {
        fc = color ? color : feature.get("color");
      }
      if (feature && feature.get("suspicious")) {
        label = new Text({
          textAlign: "center",
          textBaseline: "middle",
          font: "bold 12px/1 Verdana",
          text: feature.get("label").toString(),
          fill: new Fill({ color: fc }),
          stroke: new Stroke({ color: "#000000", width: 2 }),
          placement: "point",
          overflow: true
        });
        if (feature.get("suspicious") === false) {
          fc = "transparent";
          sc = "transparent";
          label = null;
        }
      }
      return new Style({
        stroke: new Stroke({
          color: sc,
          width: 1
        }),
        fill: new Fill({
          color: fc
        }),
        text: label
      });
    },
    setFeatureStyleGrid() {
      return new Style({
        stroke: new Stroke({
          color: "#319FD3",
          width: 1
        }),
        fill: new Fill({
          color: "transparent"
        })
      });
    },
    setFeatureStyleSelected(feature, withFill, opacity = 40) {
      let fc = "transparent";
      let sc = "#319FD3";
      let sw = 3;
      if (withFill) {
        fc = feature.get("color") + opacity.toString(16);
        sc = "transparent";
        sw = 0;
      }
      return [
        new Style({
          stroke: new Stroke({
            color: sc,
            width: sw,
          }),
          fill: new Fill({
            color: fc
          }),
          zIndex: feature.get("zIndex")
        })
      ];
    },
    getVectorLayerByLevel(level) {
      let vectorLayer = null;
      this.getVectorLayers().forEach(layer => {
        if (layer.get("level") === level) {
          vectorLayer = layer;
        }
      });
      return vectorLayer;
    },
    getVectorLayers() {
      let layers = [];
      this.map.getLayers().forEach(layer => {
        if (layer instanceof Group) {
          layer.getLayers().forEach(layer => {
            if (layer instanceof VectorLayer) {
              layers.push(layer);
            }
          });
        } else {
          if (layer instanceof VectorLayer) {
            layers.push(layer);
          }
        }
      });
      return layers;
    },
    performEventClick(e, select) {
      const create = this.allowCreateTiles && select;
      const tilesOffset = this.currentCursorSize > 1 ? this.currentCursorSize - Math.ceil(this.currentCursorSize/2) : 0;
      const coordinates = [
        e.coordinate[0] - (e.coordinate[0] % (this.tileSizeX)) + Math.sign(e.coordinate[0])*(this.tileSizeX)/2,
        e.coordinate[1] - (e.coordinate[1] % (this.tileSizeY)) + Math.sign(e.coordinate[1])*(this.tileSizeY)/2
      ]
      const features = this.getFeaturesInQuadrilateral(coordinates, [tilesOffset, tilesOffset], create);
      this.selectFeatures(features, select);
      this.map.renderSync();
    },
    selectFeatures(features, select) {
      features.forEach(feature => {
        this.selectFeaturesInsideFeature(feature, select)
      })
      this.toggleEditOverlay();
    },
    selectFeaturesInsideFeature(feature, select) {
      const isContainer = feature.get("isContainer");
      if (isContainer) {
        feature.get("featureTilesCollection").forEach(f => {
          this.selectFeature(f, select)
        })
      } 
      this.selectFeature(feature, select)
    },
    selectFeature(f, select) {
      const selectionIndex = this.selectedFeatures.indexOf(f);
      if (selectionIndex < 0 && select) {
        this.selectedFeatures.push(f);
        this.selectedFeaturesInitialState.push({
          class: f.get("class"),
          color: f.get("color")
        });
        f.setStyle(this.setFeatureStyleSelected(f, this.selectedWithFill));
      } else if (selectionIndex > -1 && !select) {
        this.restoreFeatureEdit(f);
        this.selectedFeaturesInitialState.splice(selectionIndex, 1);
        this.selectedFeatures.splice(selectionIndex, 1);
        this.setStyle(f);
      }
    },
    toggleEditOverlay() {
      this.selectedClass = null;
      if (this.selectedFeatures.length === 0) {
        this.editOverlay.hide();
      } else {
        this.editOverlay.show(this.editOverlay.content);
      }
    },
    changeClass() {
      this.selectedFeatures.forEach(f => {
        f.set("class", this.diagnosisByName[this.selectedClass].name);
        f.set("color", this.diagnosisByName[this.selectedClass].color);
        f.setStyle(this.setFeatureStyleSelected(f, true, 60));
      });
    },
    saveClassEdit() {
      // console.time("saveEdit");
      const source = this.vectorLayerAreas.getSource();
      const candidatesToAdd = [];
      const coordinatesToDelete = [];
      const affectedAreas = {};
      const areaFeaturesToRemove = [];
      // Step 1: Add all selected tile features to a candidate pool and to the negative geometry mask to delete from areas
      // console.time("step_1: selecting candidates tiles");
      this.selectedFeatures.forEach(feature => {
        // Consider only tiles, not areas
        if (!feature.get("isContainer")) {
          candidatesToAdd.push(feature);
          const container = feature.get("container");
          if (container) {
            if (affectedAreas[container] === undefined) {
              const areaFeature = source.getFeatureById(container);
              affectedAreas[container] = areaFeature
              areaFeature.get("featureTilesCollection").forEach(f => {
                coordinatesToDelete.push(f.getGeometry().getCoordinates())
                f.set("container", undefined)
                if (this.selectedFeatures.indexOf(f) < 0) {
                  this.selectedFeatures.push(f)
                }
              })
            }
          }
        }
        feature.setStyle(this.setFeatureStyle);
      });
      // console.timeEnd("step_1: selecting candidates tiles");
      // Step 2: Remove selected tile features from all area features
      // console.time("step_2: removing tiles from areas");
      if (coordinatesToDelete.length > 0) {
        const turfGeoToDelete = turf.multiPolygon(coordinatesToDelete);
        // source.forEachFeature(af => {
        Object.keys(affectedAreas).forEach(af_key => {
          const af = affectedAreas[af_key];
          const geoType = af.getGeometry().getType();
          let turfGeoArea = null;
          if (geoType === "MultiPolygon")
            turfGeoArea = turf.multiPolygon(af.getGeometry().getCoordinates());
          else turfGeoArea = turf.polygon(af.getGeometry().getCoordinates());
          const difference = turf.difference(turfGeoArea, turfGeoToDelete);
          if (difference && !turf.booleanEqual(turfGeoArea, difference)) {
            const newTurfGeo = this.format.readFeature(difference);
            af.setGeometry(newTurfGeo.getGeometry());
            // OJO PIOJO
            this.recalculateArea(af);
          } else {
            areaFeaturesToRemove.push(af);
          }
          af.setStyle(this.setFeatureStyle);
        });
      }
      areaFeaturesToRemove.forEach(af => {
        this.deleteArea(af, true);
      });
      // console.timeEnd("step_2: removing tiles from areas");
      // Step 3: Merge continuous tiles
      // console.time("step_3: merging neighbouring tiles");
      if (candidatesToAdd.length > 0) {
        this.mergeNeighbouringTiles();
      }
      this.recalculateLabels();
      // console.timeEnd("step_3: merging neighbouring tiles");
      // console.time("step_4: deleting background")
      this.selectedFeatures.forEach(f => {
        this.deleteBackgroundFeature(f);
      })
      // console.timeEnd("step_4: deleting background")
      this.clearSelection();
      // console.timeEnd("saveEdit");
    },
    getNewId(feature) {
      const label_type = this.diagnosisByName[feature.get("class").toLowerCase()].label_type;
      if (label_type === "artifact") return null;
      return "n_" + (Math.random() * +1).toString(36).substring(7);
    },
    separateAreas(feature) {
      let polygonAreas;
      if (feature.geometry.type === "MultiPolygon") {
        polygonAreas = feature.geometry.coordinates.map(c => turf.polygon(c));
      } else {
        polygonAreas = [feature];
      }
      const intersectingAreas = {};
      for (let i = 0; i < polygonAreas.length; i++) {
        const area = polygonAreas[i];
        intersectingAreas[i] = [];
        intersectingAreas[i].push(i);
        for (let j = 0; j < polygonAreas.length; j++) {
          if (i !== j && turf.booleanIntersects(area, polygonAreas[j])) {
            intersectingAreas[i].push(j);
          }
        }
      }
      const disconnectedAreas = [];
      Object.keys(intersectingAreas).forEach(area => {
        let areaArray = intersectingAreas[area];
        areaArray.forEach(neighbourArea => {
          areaArray = areaArray.concat(intersectingAreas[neighbourArea]);
        });
        areaArray = areaArray.filter((v, i, a) => a.indexOf(v) === i).sort();
        let shouldAdd = true;
        for (let i = 0; i < disconnectedAreas.length; i++) {
          if (
            JSON.stringify(areaArray) === JSON.stringify(disconnectedAreas[i])
          ) {
            shouldAdd = false;
          }
        }
        if (shouldAdd) {
          disconnectedAreas.push(areaArray);
        }
      });
      const geometries = [];
      disconnectedAreas.forEach(areaArray => {
        let coordinates = [];
        areaArray.forEach(area => {
          coordinates = coordinates.concat(
            polygonAreas[area].geometry.coordinates
          );
        });
        if (areaArray.length > 1) {
          geometries.push(turf.multiPolygon(coordinates));
        } else {
          geometries.push(turf.polygon(coordinates));
        }
      });
      return geometries;
    },
    directionalOffset() {
      const offsets = [
        [
          this.tileSizeX,
          this.tileSizeY
        ],
        [
          -this.tileSizeX,
          this.tileSizeY
        ],
        [
          this.tileSizeX,
          -this.tileSizeY
        ],
        [
          -this.tileSizeX,
          -this.tileSizeY
        ],
        [this.tileSizeX, 0],
        [0, this.tileSizeY],
        [-this.tileSizeX, 0],
        [0, -this.tileSizeY]
      ];
      return offsets;
    },
    getFeaturesInQuadrilateral(center, tilesOffset, create) {
      const features = [];
      for (let i = -tilesOffset[0]; i <= tilesOffset[0]; i++) {
        for (let j = -tilesOffset[1]; j <= tilesOffset[1]; j++) {
          let feature = null;
          const coordinates = [
            center[0] + i * this.tileSizeX,
            center[1] + j * this.tileSizeY
          ];
          const pixel = this.map.getPixelFromCoordinate(coordinates)
          feature = this.map.getFeaturesAtPixel(pixel, { hitTolerance: 1 })[0];
          // Prevent tile creation if the tile vector layer is not visible
          create = this.vectorLayerTiles.getVisible() && create;
          if (create && !feature) {
            feature = this.createTemportalTile([
              coordinates[0] - (coordinates[0] % (this.tileSizeX)),
              coordinates[1] - (coordinates[1] % (this.tileSizeY))
            ])
          }
          if (feature) {
            features.push(feature)
          }
        }
      }
      return features;
    },
    mergeNeighbouringTiles() {
      const offsets = this.directionalOffset();
      // Give neighbour tiles the same container, if none exist create one
      const featureTilesCollection = {};
      const containerToDelete = [];
      // TODO: Only iterate selected features
      // this.vectorLayerTiles.getSource().forEachFeature(feature => {
      // this.selectedFeatures.forEach(feature => {
      let featureIndexLength = this.selectedFeatures.length;
      for (let index = 0; index < featureIndexLength; index++) {
        const feature = this.selectedFeatures[index];
        const fclass = feature.get("class");
        const featureCenter = feature.get("center");
        if (!feature.get("isContainer") && fclass !== "normal" && !feature.get("container")) {
          const neighboursWithContainer = [];
          const neighboursContainer = [];
          offsets.forEach(offset => {
            const neighbourFeature = this.vectorLayerTiles
              .getSource()
              .getFeaturesAtCoordinate([
                featureCenter[0] + offset[0],
                featureCenter[1] + offset[1]
              ])[0];
            if (neighbourFeature && neighbourFeature.get("class") === fclass) {
              const neighbourContainer = neighbourFeature.get("container");
              if (neighbourContainer)
                neighboursWithContainer.push(neighbourFeature);
              neighboursContainer.push(neighbourFeature);
              if (this.selectedFeatures.indexOf(neighbourFeature) < 0) {
                this.selectedFeatures.push(neighbourFeature)
                featureIndexLength += 1;
              }
            }
          });
          if (neighboursWithContainer.length > 0) {
            let container = neighboursWithContainer[0].get("container");
            let lastNeighbour = neighboursWithContainer[0];
            for (
              let index = 0;
              index < neighboursWithContainer.length;
              index++
            ) {
              const neighbourContainer = neighboursWithContainer[index].get(
                "container"
              );
              if (!(neighbourContainer in featureTilesCollection)) {
                container = neighbourContainer;
                lastNeighbour = neighboursWithContainer[index];
                const containerGeoFea = this.addContainerFeatures(container);
                featureTilesCollection[container] = {
                  class: fclass,
                  geometry: containerGeoFea["geometry"],
                  features: containerGeoFea["features"],
                  new: false
                };
              }
              // Notify neighbour to change to an old container (to avoid creating new ones)
              neighboursContainer.forEach(neighbour => {
                const neighbourLastContainer = neighbour.get("container");
                if (
                  neighbourLastContainer &&
                  lastNeighbour.getId() !== neighbour.getId() &&
                  neighbourLastContainer !== container
                ) {
                  if (neighbourLastContainer in featureTilesCollection) {
                    featureTilesCollection[
                      neighbourLastContainer
                    ].features.forEach(feature => {
                      feature.set("container", container);
                      featureTilesCollection[container].features.push(feature);
                    });
                    featureTilesCollection[
                      neighbourLastContainer
                    ].geometry.forEach(geometry => {
                      featureTilesCollection[container].geometry.push(geometry);
                    });
                    // If the last neighbour container is an old aswell, then delete from vectorArea
                    if (!featureTilesCollection[neighbourLastContainer].new)
                      containerToDelete.push(neighbourLastContainer);
                    delete featureTilesCollection[neighbourLastContainer];
                  } else {
                    const containerGeoFea = this.addContainerFeatures(
                      neighbourLastContainer
                    );
                    containerGeoFea.features.forEach(feature => {
                      feature.set("container", container);
                      featureTilesCollection[container].features.push(feature);
                    });
                    containerGeoFea.geometry.forEach(geometry => {
                      featureTilesCollection[container].geometry.push(geometry);
                    });
                    containerToDelete.push(neighbourLastContainer);
                  }
                }
              });
              if (
                neighbourContainer in featureTilesCollection &&
                !featureTilesCollection[neighbourContainer].new
              )
                break;
            }
            featureTilesCollection[container]["geometry"].push(
              turf.polygon(feature.getGeometry().getCoordinates(), {
                area: container
              })
            );
            featureTilesCollection[container]["features"].push(feature);
            feature.set("container", container);
          } else {
            // TODO: Function to create unique IDs (UUID library = overkill)
            const newContainer = this.getNewId(feature);
            featureTilesCollection[newContainer] = {
              class: fclass,
              geometry: [],
              features: [],
              new: true
            };
            featureTilesCollection[newContainer]["geometry"].push(
              turf.polygon(feature.getGeometry().getCoordinates(), {
                area: newContainer
              })
            );
            featureTilesCollection[newContainer]["features"].push(feature);
            feature.set("container", newContainer);
          }
        }
      };
      containerToDelete.forEach(container => {
        const containerFeature = this.vectorLayerAreas.getSource().getFeatureById(container);
        if (containerFeature) {
          this.deleteArea(this.vectorLayerAreas.getSource().getFeatureById(container), true);
        }
      });
      // Create new areas or update existing ones with tiles that share the same container
      Object.keys(featureTilesCollection).forEach(container => {
        const featureCollection = turf.dissolve(
          turf.featureCollection(featureTilesCollection[container]["geometry"]),
          { area: container }
        );
        const polygons = [];
        featureCollection.features.forEach(f => {
          polygons.push(f.geometry.coordinates);
        });
        let multi = null;
        if (polygons.length > 1) multi = turf.multiPolygon(polygons);
        else multi = turf.polygon(polygons[0]);
        this.createNewArea(
          [multi, featureTilesCollection[container]["features"]],
          featureTilesCollection[container]["class"],
          featureTilesCollection[container]["new"],
          container
        );
      });
    },
    addContainerFeatures(container) {
      const features = { geometry: [], features: [] };
      this.vectorLayerTiles.getSource().forEachFeature(feature => {
        if (feature.get("container") === container) {
          let turfGeo = null;
          const geoType = feature.getGeometry().getType();
          if (geoType === "MultiPolygon")
            turfGeo = turf.multiPolygon(feature.getGeometry().getCoordinates());
          else turfGeo = turf.polygon(feature.getGeometry().getCoordinates());
          features["geometry"].push(turfGeo);
          features["features"].push(feature);
        }
      });
      return features;
    },
    recalculateArea(feature) {
      const size = getArea(feature.getGeometry()) / this.tileSize;
      feature.set("size", this.tileAreamm2 * size);
      feature.set(
        "ratio",
        (getArea(feature.getGeometry()) / this.totalSize) * 100
      );
      if (feature.get("size") >= this.suspiciousThreshold)
        feature.set("suspicious", true);
      this.$store.dispatch(ACTION_EDIT_AREA, {
        area: {
          id: feature.getId(),
          area_class_id: feature.get("area_class_id"),
          size: feature.get("size"),
          ratio: feature.get("ratio"),
          suspicious: feature.get("suspicious")
        }
      });
      this.calculateTotalAreaPercentage();
    },
    calculateTotalAreaPercentage() {
      const source = this.vectorLayerAreas.getSource();
      const ratio = {};
      source.forEachFeature(af => {
        const valid = af.get("suspicious") ? 1 : 0;
        ratio[af.get("class")] =
          ratio[af.get("class")] !== undefined
            ? ratio[af.get("class")] + af.get("ratio") * valid
            : af.get("ratio") * valid;
      });
      Object.keys(this.diagnosisByName).forEach(diagnosisClass => {
        const value =
          ratio[diagnosisClass] !== undefined ? ratio[diagnosisClass] : 0;
        this.$store.dispatch(ACTION_SET_DIAGNOSIS_RATIO, {
          diagnosisName: diagnosisClass,
          ratio: value
        });
      });
    },
    createNewArea(turfFeature, fclass, create, id) {
      const label_type = this.diagnosisByName[fclass.toLowerCase()].label_type;
      if (label_type === "artifact") return;
      const source = this.vectorLayerAreas.getSource();
      const geometry = this.format.readFeature(turfFeature[0]).getGeometry();
      let feature = source.getFeatureById(id);
      let area_class_id = "n";
      let suspicious = false;
      let created = false
      if (create || !feature) {
        created = true
        feature = new Feature({
          geometry: geometry,
          center: olExtent.getCenter(geometry.getExtent())
        });
      } else {
        area_class_id = id.split("_")[0];
      }
      // Set feature ID
      const size = this.tileAreamm2 * (getArea(geometry) / this.tileSize);
      suspicious = size >= this.suspiciousThreshold;
      if (!suspicious) {
        turfFeature[1].forEach(feature => {
          feature.set("container", undefined);
        });
        return
      }
      feature.setGeometry(geometry);
      feature.set("size", this.tileAreamm2 * size);
      feature.set("class", fclass.toLowerCase());
      feature.set("area_class_id", area_class_id);
      feature.set("color", this.diagnosisByName[fclass.toLowerCase()].color);
      feature.set(
        "ratio",
        (getArea(feature.getGeometry()) / this.totalSize) * 100
      );
      feature.set("container", null);
      feature.set("isContainer", true);
      const featureTilesCollection = []
      turfFeature[1].forEach(feature => {
        feature.set("container", id);
        featureTilesCollection.push(feature)
      });
      feature.set("featureTilesCollection", featureTilesCollection);
      feature.set("suspicious", suspicious);
      if (created) {
        feature.setId(id);
        this.addArea(feature);
        source.addFeature(feature);
      }
      // else { this.recalculateArea(feature); }
      this.recalculateArea(feature);
    },
    restoreFeatureEdit(f) {
      const index = this.selectedFeatures.indexOf(f);
      const original = this.selectedFeaturesInitialState[index];
      for (const attribute in original) {
        f.set(attribute, original[attribute]);
      }
      this.setStyle(f)
      this.deleteBackgroundFeature(f);
    },
    setStyle(feature) {
      if (this.selectedWithFill) {
        feature.setStyle(this.setFeatureStyleGrid)
      } else {
        feature.setStyle(this.setFeatureStyle);
      }
    },
    cancelClassEdit() {
      this.selectedFeatures.forEach(f => {
        this.restoreFeatureEdit(f);
      });
      this.clearSelection();
    },
    clearSelection() {
      this.selectedFeatures = [];
      this.selectedFeaturesInitialState = [];
      this.toggleEditOverlay();
    },
    countSuspiciousAreas() {
      const areaCounter = {};
      const source = this.vectorLayerAreas.getSource();
      source.forEachFeature(areaFeature => {
        const fclass = areaFeature.get("class");
        if (areaFeature.get("suspicious"))
          areaCounter[fclass] = areaCounter[fclass]
            ? areaCounter[fclass] + 1
            : 1;
      });
      Object.keys(areaCounter).forEach(fclass => {
        this.$store.dispatch(ACTION_SET_DIAGNOSIS_COUNT, {
          diagnosisName: fclass,
          count: areaCounter[fclass]
        });
      });
      Object.keys(this.diagnosisByName).forEach(diagnosis => {
        const count = areaCounter[diagnosis] ? areaCounter[diagnosis] : 0;
        this.$store.dispatch(ACTION_SET_DIAGNOSIS_COUNT, {
          diagnosisName: diagnosis,
          count: count
        });
      });
    },
    setVectorSource() {
      // this.tileSize = this.reportTileGrid.tilegrid_json["general"]["tile_area_mm2"];
      const tile_w = this.tileSizeX;
      const tile_h = this.tileSizeY;
      const turfTilesCollection = {};
      const featureTilesCollection = {};
      Object.keys(this.reportTileGrid.tilegrid_json["tiles"]).forEach(tile => {
        const id = tile;
        tile = this.reportTileGrid.tilegrid_json["tiles"][tile];
        // Change in CDSS: tiles that belong to an non suspcious area should have area_id = null
        let area = tile["area_id"];
        if (area && !this.reportTileGrid.tilegrid_json["areas"][area.split("_")[0]][area]["suspicious"]) {
          area = null;
        }
        let classType = tile["label"].toLowerCase();
        // FIX LOCALIZATION FROM CDSS
        if (classType === "otro") classType = "other";
        else if (classType === "artefactos") classType = "artifact";
        else if (classType === "tejido con artefacto") classType = "tissue with artifact";
        const classDef = this.diagnosisByName[classType];
        // Skip artifact areas
        if (classDef.label_type === "artifact") area = null;
        // Ignore background tiles
        if (classType === "background") return;
        const _x = parseInt(tile["col"]) * this.scalingFactor;
        const _y = parseInt(tile["row"]) * this.scalingFactor;
        const color = classDef.color;
        const geometry = new Polygon([
          [
            [_x, -_y],
            [_x + tile_w, -_y],
            [_x + tile_w, -_y - tile_h],
            [_x, -_y - tile_h],
            [_x, -_y]
          ]
        ]);
        // Replace with value from cdss
        this.tileSize = getArea(geometry);
        this.totalSize += this.tileSize;
        const feature = new Feature({
          geometry: geometry,
          class: classDef.name,
          color: color,
          container: area,
          center: olExtent.getCenter(geometry.getExtent()),
        });
        feature.setId(id);
        this.featuresTiles.push(feature);
        if (area !== null) {
          if (!(area in turfTilesCollection)) turfTilesCollection[area] = [];
          if (!(area in featureTilesCollection)) featureTilesCollection[area] = [];
          turfTilesCollection[area].push(turf.polygon(geometry.getCoordinates(), { area: area }));
          featureTilesCollection[area].push(feature);
        }
      });
      Object.keys(this.reportTileGrid.tilegrid_json["areas"]).forEach(areas => {
        const area_class_id = areas;
        areas = this.reportTileGrid.tilegrid_json["areas"][areas];
        Object.keys(areas).forEach(area => {
          const id = area;
          area = areas[area];
          let classType = area["class"].toLowerCase();
          // FIX LOCALIZATION FROM CDSS
          if (classType === "otro") classType = "other";
          else if (classType == "artefactos") classType = "artifact";
          else if (classType === "tejido con artefacto") classType = "tissue with artifact";
          const classDef = this.diagnosisByName[classType];
          // Skip artifact areas
          if (classDef.label_type === "artifact") return;
          const size = area["area"];
          const ratio = area["rate"];
          // TODO: Calculate in case the suspicios area treshold changes
          const suspicious = area["suspicious"];
          if (suspicious) {
            let geometry = null;
            const featureCollection = turf.dissolve(
              turf.featureCollection(turfTilesCollection[id]),
              { area: id }
            );
            const polygons = [];
            featureCollection.features.forEach(f => {
              polygons.push(f.geometry.coordinates);
            });
            let multi = null;
            if (polygons.length > 1) multi = turf.multiPolygon(polygons);
            else multi = turf.polygon(polygons[0]);
            geometry = this.format.readFeature(multi).getGeometry();
            const color = classDef.color;
            const feature = new Feature({
              geometry: geometry,
              area_class_id: area_class_id,
              class: classDef.name,
              class_type: classDef.label_type,
              color: color,
              suspicious: suspicious,
              size: size,
              zIndex: classDef.priority,
              ratio: ratio,
              container: null,
              isContainer: true,
              featureTilesCollection: featureTilesCollection[id],
            });
            feature.setId(id);
            this.setLabel(feature)
            this.featureAreas.push(feature);
          }
        });
      });
      this.vectorLayerTiles.getSource().addFeatures(this.featuresTiles);
      this.vectorLayerAreas.getSource().addFeatures(this.featureAreas);
      this.countSuspiciousAreas();
      this.calculateTotalAreaPercentage();
    },
    async save() {
      // Save all tiles
      this.saving = true;
      const updatedTileGrid = JSON.parse(JSON.stringify(this.reportTileGrid));
      this.featuresTiles.forEach(feature => {
        const originalValue = updatedTileGrid.tilegrid_json.tiles[
          feature.getId()
        ].label.toLowerCase();
        const lastValue = feature.get("class");
        const modified = originalValue !== lastValue;
        updatedTileGrid.tilegrid_json.tiles[feature.getId()]["modified"] = modified;
        updatedTileGrid.tilegrid_json.tiles[feature.getId()].label = lastValue;
        updatedTileGrid.tilegrid_json.tiles[
          feature.getId()
        ].area_id = feature.get("container");
        if (modified) {
          updatedTileGrid.tiles_modified_count += 1;
          updatedTileGrid.modified_tiles.push(feature.getId());
        }
      });
      this.vectorLayerAreas.getSource().forEachFeature(feature => {
          updatedTileGrid.tilegrid_json.areas[feature.getId().split("_")[0]][
            feature.getId()
          ].class = feature.get("class");
          updatedTileGrid.tilegrid_json.areas[feature.getId().split("_")[0]][
            feature.getId()
          ].area = feature.get("size");
          updatedTileGrid.tilegrid_json.areas[feature.getId().split("_")[0]][
            feature.getId()
          ].rate = feature.get("ratio");
        });
      await this.$store.dispatch(UPDATE_REPORT, updatedTileGrid);
      this.saving = false;
      this.$router.push({ name: "service-reportform", params: { id: this.$store.getters[CURRENT_REPORTWSI].id } });
    },
    setLabel(feature) {
      if (feature.get("suspicious")) {
        this.areaLabelDict[feature.getId()] = feature;
        this.areaLabelArray.push(feature.getId());
        feature.set("label", this.areaLabelArray.length);
        this.$store.dispatch(ACTION_SET_LABEL, {
          id: feature.getId(),
          label: this.areaLabelArray.length,
        });
      }
    },
    removeLabel(feature) {
      const index = this.areaLabelArray.indexOf(feature.getId());
      if (index !== -1) {
        this.areaLabelArray.splice(index, 1);
        delete this.areaLabelDict[index];
      }
    },
    recalculateLabels() {
      this.areaLabelArray.forEach((id, index) => {
        this.$store.dispatch(ACTION_SET_LABEL, {
          id: id,
          label: index + 1,
        });
        this.areaLabelDict[id].set("label", index + 1);
      })
    },
    createTemportalTile(position) {
      const id = md5(position.join());
      let area = null;
      let classType = 'background';
      const classDef = this.diagnosisByName[classType];
      const tile_w = this.tileSizeX;
      const tile_h = this.tileSizeY;
      const _x = position[0] * this.scalingFactor;
      const _y = -position[1] * this.scalingFactor;
      const color = classDef.color;
      const geometry = new Polygon([
        [
          [_x, -_y],
          [_x + tile_w, -_y],
          [_x + tile_w, -_y - tile_h],
          [_x, -_y - tile_h],
          [_x, -_y]
        ]
      ]);
      this.tileSize = getArea(geometry);
      this.totalSize += this.tileSize;
      const feature = new Feature({
        geometry: geometry,
        class: classDef.name,
        color: color,
        zIndex: classDef.priority,
        container: area,
        center: olExtent.getCenter(geometry.getExtent())
      });
      feature.setId(id);
      // feature.setStyle(this.setFeatureStyle(feature, true, color));
      this.addTile(feature, {
        label: classDef.name,
        area_id: null,
        col: _x,
        row: _y,
      })
      return feature;
    },
    deleteBackgroundFeature(feature) {
      if (feature.get("class") === 'background') {
        // Delete area from area vector source
        if (feature.get("isContainer")) {
          const source = this.vectorLayerAreas.getSource()
          if (source.getFeatureById(feature.getId())) {
            source.removeFeature(feature);
          }
        } else {
          this.deleteTile(feature);
        }
      }
    },
    // Insted of outright delete, flag it for deletion and delete on save
    deleteTile(feature) {
      if (feature.get("container")) {
        const areaFeature = this.vectorLayerAreas.getSource().getFeatureById(feature.get("container"));
        areaFeature.get("featureTilesCollection").remove(feature);
      }
      this.vectorLayerTiles.getSource().removeFeature(feature);
      const index = this.featuresTiles.indexOf(feature);
      if (index > -1) {
        this.featuresTiles.splice(index, 1);
      }
      this.$store.dispatch(ACTION_DELETE_TILE, {
        tile: { id: feature.getId() }
      });
    },
    addTile(feature, attributes) {
      this.vectorLayerTiles.getSource().addFeature(feature);
      this.featuresTiles.push(feature);
      let artifact = 0;
      if (["artifact", "tissue with artifact"].includes(feature.get("class"))) {
        artifact = 1
      }
      this.$store.dispatch(ACTION_ADD_TILE, {
        tile: { 
          id: feature.getId(),
          label: attributes.label,
          area_id: attributes.area_id,
          col: attributes.col,
          row: attributes.row,
          modified: true,
          Tissue: 1 - artifact,
          Artifact: artifact,
          Background: 0,
          prob_comun: 0,
          prob_tumor: 0,
          prob_normal: 0,
          prob_adenoma: 0,
          prob_adenocarcinoma: 0,
          prob_cascada_normal_otro_adenoc_adenoma: [
            0, 0, 0, 0
          ],
        }
      });
    },
    setToggleClass(size) {
      const active = this.currentCursorSize === size;
      const id = `size-${size}`;
      const icon = `mdi mdi-numeric-${size}-box`;
      const iconClass = active ? icon + "-outline" : icon;
      document.getElementById(id).className = iconClass;
      this.setToggleActiveClass(size, active);
    },
    setToggleActiveClass(size, active) {
      const id = `size-${size}`
      const activeClass = "ol-active";
      if (active) {
        document.getElementsByClassName(id)[0].classList.add(activeClass);
      } else {
        document.getElementsByClassName(id)[0].classList.remove(activeClass);
      }
    },
    reverseChildren(parent) {
      for (var i = 1; i < parent.childNodes.length; i++){
          parent.insertBefore(parent.childNodes[i], parent.firstChild);
      }
    },
  },
  mounted() {
    // Base
    let projection = new Projection({
      code: "pixel",
      units: "pixels",
      extent: this.extent
    });

    let source = new Zoomify({
      url: `${process.env.VUE_APP_IIPSRV_PATH}?zoomify=${this.slide.path}/`,
      size: [this.imageWidth, this.imageHeight],
      // crossOrigin: "anonymous",
      projection: projection
    });

    // Tilegrid data
    let layerSlide = new Tile({
      title: this.$t("report.visualizationView.wsi"),
      extent: this.extent,
      source: source,
      wrapX: false,
      projection: projection,
      preload: Infinity
    });

    this.vectorLayerAreas = new VectorLayer({
      title: this.areaLayerTitle,
      name: "areas",
      extent: this.extent,
      minResolution: this.resolutionAt10x*10, // Autohide at magnification 1x
      renderBuffer: 1,
      visible: false,
      source: new VectorSource({
        features: this.featureAreas
      }),
      style: this.setFeatureStyle,
      level: 0
    });
    this.vectorLayerTiles = new VectorLayer({
      title: this.tileLayerTitle,
      extent: this.extent,
      // minZoom: 3,
      renderBuffer: 1,
      visible: false,
      source: new VectorSource({
        features: this.featuresTiles,
        wrapX: false
      }),
      style: this.setFeatureStyle,
      level: 1
    });
    const vectorGroup = new Group({
      name: "classification_group",
      title: this.$t("report.visualizationView.classification"),
      openInLayerSwitcher: true,
      layers: [this.vectorLayerTiles, this.vectorLayerAreas]
    });
    
    // Map
    // Extend with extra margin
    const viewExtent = [
      -this.imageWidth * 0.4,
      -this.imageHeight * 1.4,
      this.imageWidth * 1.4,
      this.imageHeight * 0.4
    ];
    this.map = new Map({
      keyboardEventTarget: document,
      interactions: defaultInteractions({
        doubleClickZoom: false
      }),
      controls: defaultsControls().extend([new FullScreen()]),
      // controls: defaultsControls().extend([new FullScreen(), overviewMapControl]),
      layers: [layerSlide, vectorGroup],
      units: "pixels",
      maxTilesLoading: 32,
      logo: false,
      moveTolerance: 10,
      loadTilesWhileAnimating: true,
      loadTilesWhileInteracting: true,
      view: new View({
        center: olExtent.getCenter(viewExtent),
        zoom: 3,
        maxZoom: 10,
        projection: projection,
        extent: viewExtent
      })
    });

    // Controls
    // Report Overlay
    const reportOverlay = new Overlay({
      className: "menu reportWindow",
      content: document.getElementById("menu")
    });
    this.map.addControl(reportOverlay);
    const toggleReport = new Toggle({
      html: '<i id="report-overlay" class="mdi mdi-clipboard-file"></i>',
      className: "menu",
      active: false,
      title: this.$t("report.visualizationView.reportTooltip", { menu: this.$t("report.visualizationView.reportTitle") }),
      onToggle: active => {
        document.getElementsByClassName("reportWindow")[0].style.display = active ? "none" : "block";
        document.getElementById("report-overlay").className = active ? "mdi mdi-clipboard-file-outline" : "mdi mdi-clipboard-file";
        reportOverlay.toggle();
      }
    });
    // Edit Tiles Overlay
    this.editOverlay = new Overlay({
      closeBox: false,
      className: "slide-bottom menu",
      content: document.getElementById("edit")
    });
    this.map.addControl(this.editOverlay);
    // ZoomSlider
    const zoomslider = new ZoomSlider();
    this.map.addControl(zoomslider);
    // LayerSwitcher
    const layerSwitcher = new LayerSwitcher({
      reordering: false,
      collapsed: false
    })
    this.map.addControl(layerSwitcher);
    // Show/Hide grid/fill color
    const hideGrid = new Toggle({
      html: '<i id="hide-grid" class="mdi mdi-grid"></i>',
      title: this.$t("report.visualizationView.gridColorTooltip"),
      active: false,
      onToggle: active => {
        this.selectedWithFill = !this.selectedWithFill;
        this.vectorLayerTiles.getSource().forEachFeature(f => {
          this.setStyle(f);
        })
        if (active) {
          this.selectedFeatures.forEach(f => {
            f.setStyle(this.setFeatureStyleSelected(f, this.selectedWithFill));
          });
          document.getElementById("hide-grid").className = "mdi mdi-grid-off";
        } else {
          this.selectedFeatures.forEach(f => {
            f.setStyle(this.setFeatureStyleSelected(f, this.selectedWithFill));
          });
          document.getElementById("hide-grid").className = "mdi mdi-grid";
        }
      }
    });
    // Enable/Disable edition of background
    const editBackground = new Toggle({
      html: '<i id="edit-background" class="mdi mdi-view-grid-plus"></i>',
      title: this.$t("report.visualizationView.editBackgroundTooltip"),
      active: false,
      onToggle: active => {
        this.allowCreateTiles = active
        if (active) {
          document.getElementById("edit-background").className = "mdi mdi-view-grid-plus-outline";
        } else {
          document.getElementById("edit-background").className = "mdi mdi-view-grid-plus";
        }
      }
    })
    // Select cursor size control bar
    const cursorSizesToggle = []
    this.cursorSizes.forEach(size => {
      cursorSizesToggle.push(
        new Toggle({
          className: `size-${size}`,
          html: `<i id="size-${size}" class="mdi mdi-numeric-${size}-box${size === 1 ? '-outline' : ''}"></i>`,
          title: this.$t("report.visualizationView.cursorSizeTooltip", { size: size }),
          onToggle: () => {
            this.currentCursorSize = size;
            this.cursorSizes.forEach(s => {
              this.setToggleClass(s);
            })
          }
        })
      )
    })
    const subSizeBar = new Bar({
      toggleOne: true,
      group: false,
      controls: cursorSizesToggle,
    })
    const toggleCursorSize = new Toggle({
      html: '<i id="size-bar" class="mdi mdi-cursor-default-click"></i>',
      bar: subSizeBar,
      title: this.$t("report.visualizationView.sizeBarTooltip"),
      onToggle: active => {
        document.getElementById("size-bar").className = active ? "mdi mdi-cursor-default-click-outline" : "mdi mdi-cursor-default-click";
        this.cursorSizes.forEach(s => {
          const active = this.currentCursorSize === s;
          this.setToggleActiveClass(s, active);
        })
      }
    })
    const deselect = new Toggle({
      html: '<i id="deselect-bar" class="mdi mdi-square-off"></i>',
      title: this.$t("report.visualizationView.deselectTooltip"),
      onToggle: active => {
        document.getElementById("deselect-bar").className = active ? "mdi mdi-square-off-outline" : "mdi mdi-square-off";
        this.deselectMode = active;
      }
    })
    // Control bar
    const mainBar = new Bar({
      position: "top"
    })
    const controlBarOverlay = new Bar({ group: true });
    const controlBarVisualization = new Bar({ group: true });
    const controlBarFunctionalities = new Bar({ group: true });
    controlBarOverlay.addControl(toggleReport);
    controlBarVisualization.addControl(hideGrid);
    controlBarFunctionalities.addControl(editBackground);
    controlBarFunctionalities.addControl(toggleCursorSize);
    controlBarFunctionalities.addControl(deselect);

    mainBar.addControl(controlBarOverlay);
    mainBar.addControl(controlBarVisualization);
    mainBar.addControl(controlBarFunctionalities);
    this.map.addControl(mainBar)

    // Legend
    var legend = new Legend({
      title: this.$t("report.visualizationView.legend")
    });
    var legendControl = new LegendControl({
      legend: legend,
      title: this.$t("report.visualizationView.legendTooltip"),
      collapsed: false
    });
    this.map.addControl(legendControl);
    const sorted_diagnosis = [
      "normal",
      "adenocarcinoma",
      "adenoma",
      "other",
      "artifact",
      "tissue with artifact"
    ];
    // for (const key in this.diagnosisByName) {
    sorted_diagnosis.forEach(key => {
      legend.addItem({
        title: this.$t('report.' + key),
        class: this.diagnosisByName[key].name,
        typeGeom: "Polygon",
        className: "center",
        active: true,
        style: this.setFeatureStyle(
          undefined,
          true,
          this.diagnosisByName[key].color
        ),
        styleToggle: this.setFeatureStyle(
          undefined,
          false,
          this.diagnosisByName[key].color
        )
      });
    });

    // Select legend
    legend.on("select", e => {
      const filter = e.item.get("class");
      const active = e.item.get("active");
      const style = e.item.get("style");
      // Toggle legend item
      e.item.set("active", !active);
      e.item.set("style", e.item.get("styleToggle"));
      e.item.set("styleToggle", style);
      // Toggle layer features
      this.toggleFilterFeatures(filter, active);
      legend.refresh();
    });

    // Select tiles
    this.map.on("click", e => {
      this.performEventClick(e, !this.deselectMode);
    });
    addEventListener("contextmenu", this.map);
    this.map.on("contextmenu", e => {
      if (e.originalEvent.target.tagName === "CANVAS") {
        this.performEventClick(e, false);
      }
    })
    // set target after a little delay to allow for correct rendering of the div first
    setTimeout(() => this.map.setTarget("openviewer"), 10);

    // On zoom update current magnification
    const resolutionAt10x = this.resolutionAt10x;
    const magnificationText = this.$t('report.visualizationView.magnification')
    const ctrl = (function(Control) {
      let label = document.createElement("span");
      let baseResolution = resolutionAt10x;

      function ZoomLevelControl(options) {
        updateHtml(options.map.getView().getResolution());
        const element = document.createElement("div");
        element.setAttribute("id", "label-zoom-level");
        element.classList.add("ol-control", "zoom-level");
        element.appendChild(label);
        Control.call(this, { element, target: options.target });
      }

      function updateHtml(resolution) {
        const zoomLevel = (baseResolution / resolution) * 10
        label.innerHTML = `${magnificationText}: ${Math.round(
          (zoomLevel + Number.EPSILON) * 100
        ) / 100}x`;
      }

      if (Control) ZoomLevelControl.__proto__ = Control;
      ZoomLevelControl.prototype = Object.create(Control && Control.prototype);
      ZoomLevelControl.prototype.constructor = ZoomLevelControl;

      ZoomLevelControl.prototype.update = function update() {
        updateHtml(
          this.getMap().getView().getResolution()
        );
      };
      return ZoomLevelControl;
    })(Control);
    
    const zoomLvlCtrl = new ctrl({ map: this.map });
    this.map.addControl(zoomLvlCtrl);

    this.map.on("moveend", () => {
      const resolutionAt40x = this.resolutionAt10x / 4; // Max resolution at 40x magnification
      if (this.map.getView().getResolution() < resolutionAt40x) {
        this.map.getView().setResolution(resolutionAt40x);
      }
      zoomLvlCtrl.update();
    });


    // Custom header on layerswitcher, custom toggle
    layerSwitcher.on("toggle", e => {
      const rowClass = "pb-1";
      const colButtonClass = "col-md-2";
      if (e.collapsed) {
        document.getElementById("opacity-title-col").style.display = "none";
        document.getElementById("opacity-header-row").classList.remove(rowClass);
        document.getElementById("opacity-button-col").classList.remove(colButtonClass);
        document.getElementById("opacity-icon").classList = "mdi mdi-layers-triple-outline";
      } else {
        document.getElementById("opacity-title-col").style.display = null;
        document.getElementById("opacity-header-row").classList.add(rowClass);
        document.getElementById("opacity-button-col").classList.add(colButtonClass);
        document.getElementById("opacity-icon").classList = "mdi mdi-layers-triple";
      }
    })
    

    window.addEventListener("resize", this.resize);
    this.resize();
    this.setVectorSource();
    this.map.once(["postrender"], _ => {
      // OverviewMapControl/MiniMap
      const overviewMapControl = new Overview({
        layers: [
          new Tile({
            source: source
          })
        ],
        title: this.$t("report.visualizationView.overviewmapTooltip"),
        maxZoom: 15,
        minZoom: 10,
        align: "bottom-right"
      });
      this.map.addControl(overviewMapControl);
      document.getElementsByClassName("ol-overview")[0].querySelector("button").click();
      // Reverse layerswitch order
      // Currently there is no API to manipulate the order the layers in the layerswitcher
      const layerSwitcherElement = document.getElementsByClassName("ol-layerswitcher")[0]
      const layerSwitcher_ul = [
        layerSwitcherElement.querySelector("ul"),
        layerSwitcherElement.querySelector("ul").querySelector("ul"),
      ]
      layerSwitcher_ul.forEach(element => { this.reverseChildren(element); });
      document.getElementsByClassName("ol-layerswitcher-buttons").forEach(element => { element.innerHTML = ''; });

      // Add title to layerswitcher
      const row = document.createElement("div");
      const colTitle = document.createElement("div");
      const colButton = document.createElement("div");
      const button = layerSwitcherElement.getElementsByTagName("button")[0];
      const buttonIcon = document.createElement("i")
      const title = document.createElement("div");
      const titleText = this.$t("report.visualizationView.opacityTitle");
      const titleTextElement = document.createTextNode(titleText);
      row.classList.add("row", "no-gutters", "d-flex", "align-center", "pb-1");
      row.setAttribute("id", "opacity-header-row");
      colTitle.classList.add("col-md-10", "col-12", "text-left");
      colTitle.setAttribute("id", "opacity-title-col");
      colButton.classList.add("col-md-2");
      colButton.setAttribute("id", "opacity-button-col");
      button.style.float = "right";
      button.appendChild(buttonIcon)
      buttonIcon.setAttribute("id", "opacity-icon");
      buttonIcon.classList.add("mdi", "mdi-layers-triple");
      title.appendChild(titleTextElement);
      title.classList.add("ol-title", "ml-2");
      title.style.fontWeight = "bold";
      layerSwitcherElement.insertBefore(row, layerSwitcherElement.firstChild).appendChild(colTitle).append(title);
      layerSwitcherElement.insertBefore(row, layerSwitcherElement.firstChild).appendChild(colButton).append(button);

      // On layer opacity 0% deselect this layer visibility
      const areaCheckbox = document.querySelector(`[title="${this.areaLayerTitle}"]`);
      const tileCheckbox = document.querySelector(`[title="${this.tileLayerTitle}"]`);
      const areaSlider = areaCheckbox.parentElement;
      const tileSlider = tileCheckbox.parentElement;
      const areaValue = areaSlider.getElementsByClassName("layerswitcher-opacity-label")[0];
      const tileValue = tileSlider.getElementsByClassName("layerswitcher-opacity-label")[0];
      // Deprecated -> use observer instead
      areaValue.addEventListener("DOMSubtreeModified", _ => {
        const isVisible = areaSlider.parentElement.classList.contains('ol-visible');
        const isZero = parseInt(areaValue.innerHTML) === 0;
        if (isVisible === isZero) {
          areaCheckbox.click();
        }
      })
      tileValue.addEventListener("DOMSubtreeModified", _ => {
        const isVisible = tileSlider.parentElement.classList.contains('ol-visible');
        const isZero = parseInt(tileValue.innerHTML) === 0;
        if (isVisible === isZero) {
          tileCheckbox.click();
        }
      })

      // Disable tile & area layers by default
      // areaCheckbox.click();
      // tileCheckbox.click();
    });
  },
  components: {
    ReportDetails
  }
};
</script>
<style scoped>
>>>.zoom-level {
  bottom: 0% !important;
  right: 0.5em !important;
}
>>>.ol-overview {
  position: absolute !important;
  right: 0.5em !important;
  text-align: left !important;
  bottom: 2em !important;
}
>>>.scrollable {
  overflow-y: auto;
}
>>> .slide-bottom {
  width: 300px !important;
  margin-right: auto !important;
  margin-left: auto !important;
  height: fit-content !important;
  bottom: 0% !important;
  top: auto !important;
  left: 0%;
  right: 0%;
}
/* Legend */
>>> .ol-control.ol-legend {
  right: 0.5em !important;
  left: auto !important;
  bottom: 12em !important;
  max-height: 50% !important;
  max-width: 50% !important;
}
/* Zoom */
>>> .ol-zoom {
  top: 2.5em !important;
  right: 0.5em !important;
  left: auto !important;
}
/* Zoom Slider */
>>> .ol-zoomslider {
  top: 6.5em !important;
  right: 0.5em !important;
  left: auto !important;
  height: 200px !important;
}
/* Layer Switcher */
>>> .ol-layerswitcher {
  position: absolute !important;
  right: 2.5em !important;
  text-align: left !important;
  top: 0.5em !important;
  max-height: calc(100% - 6em) !important;
  box-sizing: border-box !important;
  overflow: hidden !important;
}
/* Report Overlay */
>>> .ol-overlay.menu {
  width: 30%;
  max-width: 500px;
  background: #fff;
  color: #333;
  box-shadow: 0px 0px 5px #000;
  padding: 0.5em;
  -webkit-transition: all 0.25s;
  transition: all 0.25s;
}
/* style the close box */
>>> .ol-overlay.menu .ol-closebox {
  color: #369;
  left: 1em;
  top: 0.5em;
}
>>> .ol-overlay.menu .ol-closebox:before {
  /* content:"\2716"; */
  content: "\D7";
}
>>> #menu {
  padding-top: 0.5em;
  font-size: 0.9em;
}
/* menu button */
>>> .ol-control.menu {
  top: 0.5em;
  left: 0.5em;
}
>>> .ol-control.menu i {
  color: #fff;
}
>>> .ol-rotate {
  right: 3em;
}
>>> .ol-touch .ol-rotate {
  right: 3.5em;
}
/**/
>>> .ol-overlay img {
  max-width: 90%;
}
>>> .data,
>>> .data p {
  margin: 0;
  text-align: center;
  font-size: 0.9em;
}
/* Map */
>>> #openviewer {
  height: 100%;
  width: 100%;
}
>>> .ol-bar {
  font-size: 22px;
}
/* >>> .ol-bar .ol-group {
  padding-left: 4px !important;
  padding-right: 4px !important;
} */
>>> .ol-bar.ol-group:first-child {
  padding-left: 0px !important;
}
>>> .ol-bar.ol-group:last-child {
  padding-right: 0px !important;
}
>>> .ol-bar.ol-bar.ol-bar.ol-group {
  padding-left: 2px;
  padding-right: 2px;
}
>>> .ol-bar.ol-group:first-child .ol-control:last-child > button {
  border-radius: 5px !important;
}
>>> .ol-bar.ol-group:nth-child(2) .ol-control:last-child > button {
  border-radius: 5px !important;
}
>>>.ol-control.ol-bar .ol-control.ol-option-bar {
    display: none;
    position: absolute;
    top: 100%;
    left: 0;
    margin: 11px 0;
    padding: 2px;
    border-radius: 4px;
    box-shadow: 0 0 0 0;
    background-color: rgba(255,255,255, 0.4);
}
/* The zoom slider of the slideviewer: ol-zoom.. */
/* .ol-zoomslider {
  left: unset !important;
  right: 8px !important;
  top: 40px;
}
.ol-zoom {
  left: unset !important;
  right: 0.5em;
  top: 40px !important;
}
.ol-zoom-in {
  top: 35px;
}
.ol-zoom-out {
  margin-top: 240px !important;
  left: unset !important;
  right: 8px;
  top: 30px;
}
.ol-full-screen {
  top: 0 !important;
} */
</style>
